import { connect } from 'react-redux'
import { IStoreState } from '../../types/index'
import AddModelModal from 'src/components/global-settings/AddModelModal'
import { createVehicleModel, getVehicleCreateOptions } from 'src/state/actions/vehicles'

const mapStateToProps = (state: IStoreState, ownProps: any): any => {
  return {
    makes: state.vehicleCreateOptions.makes
  }
}

const mapDispatchToProps = (dispatch: any): any => {
  return {
    createVehicleModel: (name: string, makeId: string) => {
      return new Promise((approve, reject) => {
        dispatch(createVehicleModel(name, makeId)).then(() => {
          dispatch(getVehicleCreateOptions()).then(() => {
            approve()
          })
        })
      })
    },
    getVehicleCreateOptions: () => dispatch(getVehicleCreateOptions())
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddModelModal)



// WEBPACK FOOTER //
// ./src/containers/global-settings/AddModelModal.ts